import React from 'react';
import { portalCopy } from '../copy';
import type { BusinessAnalytics } from '../types';

type AnalyticsKpiGridProps = {
  analytics: BusinessAnalytics;
};

const AnalyticsKpiGrid: React.FC<AnalyticsKpiGridProps> = ({ analytics }) => {
  const items = [
    { label: portalCopy.business.kpis.plans, value: analytics.plansThisMonth },
    { label: portalCopy.business.kpis.participants, value: analytics.participantsThisMonth },
    { label: portalCopy.business.kpis.profileViews, value: analytics.profileViewsThisMonth },
    { label: portalCopy.business.kpis.mapViews, value: analytics.mapViewsThisMonth },
    { label: portalCopy.business.kpis.webClicks, value: analytics.webClicksThisMonth },
    { label: portalCopy.business.kpis.instagramClicks, value: analytics.instagramClicksThisMonth },
  ];

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((item) => (
        <div
          key={item.label}
          className="rounded-[20px] border border-[rgba(74,33,71,0.1)] bg-white p-5"
        >
          <p className="font-jakarta text-sm text-[#5a3158]">{item.label}</p>
          <p className="mt-2 font-instrument text-4xl italic tabular-nums text-chisme-primary">
            {item.value.toLocaleString('es-ES')}
          </p>
        </div>
      ))}
    </div>
  );
};

export default AnalyticsKpiGrid;
